import * as React from 'react';
import type { SVGProps } from 'react';

const IconCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M.85 2.552h19.758m-19.758 0v17.07h19.758V2.552m-19.758 0v5.244h19.758V2.552M7.675 5.339V.14m6.111 5.2V.14"
    />
  </svg>
);

export default IconCalendar;
